import * as yup from 'yup';
import { fieldValidationMessages } from 'app/constants';
import { mod11_2 } from 'cdigit';
import { ISNIRegex } from './regex';

export const stringValidation = (max: number) =>
  yup.string().max(max, fieldValidationMessages.MAX_CHAR(max)).trim();

export const isniValidation = (pattern?: string) => {
  const message = 'Invalid ISNI';
  return yup
    .string()
    .test('validate-isni', function v(value) {
      if (value && !mod11_2.validate(value)) {
        return this.createError({ message });
      }
      return true;
    })
    .matches(pattern ? new RegExp(pattern) : ISNIRegex, {
      message,
      excludeEmptyString: true,
    });
};
